/** HowItWorks — the four-step Autopilot → approve → create → measure loop. */

import { useT } from '@/i18n';
import { SectionHeading } from './shared';

const STEPS = ['s1', 's2', 's3', 's4'] as const;

export function HowItWorks() {
  const { t } = useT();
  return (
    <section id="comment" className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
      <SectionHeading eyebrow={t('routes.landing.v2.how.eyebrow')} title={t('routes.landing.v2.how.title')} />
      <ol className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <li key={s} className="relative rounded-token-lg border border-border bg-surface p-6 shadow-elevation-1">
            <span
              aria-hidden="true"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-indigo-600 to-violet-600 text-base font-bold text-white"
            >
              {i + 1}
            </span>
            <h3 className="mt-4 text-lg font-semibold text-foreground">{t(`routes.landing.v2.how.${s}Title`)}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted">{t(`routes.landing.v2.how.${s}Text`)}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
